import { PROGRESS } from 'config/config';
import { getContainerHeight } from 'helpers/commonHelper';
import React, { createRef, PureComponent, RefObject } from 'react';

import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import withContext from '../../hoc/withContext';
import withTextContext from '../../hoc/withTextContext';

interface IProps extends IAccordionWrapper, IContext, RouteComponentProps<{ paymentId: string }> {
  paymentMethods: IMethod[];
}

class clickToPay extends PureComponent<IProps> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  clickToPayPaymentMethodId = '';

  async componentDidMount() {
    const { paymentMethods, setHeight } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
    this.clickToPayPaymentMethodId = paymentMethods[0].id;
  }

  componentDidUpdate() {
    if (this.shouldRefreshState()) {
      const { setHeight } = this.props;
      setHeight(getContainerHeight(this.containerRef.current));
    }
  }

  shouldRefreshState() {
    const { paymentMethodId, progress } = this.props;

    return this.clickToPayPaymentMethodId === paymentMethodId && progress < PROGRESS.SELECT_C2P_METHOD;
  }

  render() {
    return <div className="clickToPay__container" ref={this.containerRef} />;
  }
}

export default withContext(withTextContext(withRouter(clickToPay)));
